import React from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';
import useMobile from '../hooks/use-mobile';
import Colors from '../colors';
const styles = StyleSheet.create({
  container: {
    borderRadius: 5,
    display: 'flex',
    maxWidth: 545,
    padding: 60,
    margin: 'auto',
    flexDirection: 'column',
    alignItems: 'flex-start',
    boxShadow: '0px 6px 12px 0px rgba(41, 53, 61, 0.45)'
  },
  mobileContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 30
  }
});
export default function Container(props) {
  const isMobile = useMobile();

  if (isMobile) {
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.mobileContainer, {
        backgroundColor: props.backgroundColor
      }]
    }, props.children);
  }

  return /*#__PURE__*/React.createElement(View, {
    style: [styles.container, {
      paddingBottom: props.paddingBottom,
      backgroundColor: props.backgroundColor
    }]
  }, props.children);
}
Container.defaultProps = {
  paddingBottom: 0,
  backgroundColor: Colors.white
};
Container.propTypes = {
  children: PropTypes.node.isRequired,
  paddingBottom: PropTypes.number,
  backgroundColor: PropTypes.node
};
//# sourceMappingURL=container.js.map